import type { ItineraryPathData, ItineraryParams } from './itinerary';

export enum TripType {
    OneWay = 'oneway',
    RoundTrip = 'round',
}

export interface TripPathData extends ItineraryPathData {
    origin: string;
    destination: string;
    departureDate?: string;
    returnDate?: string;
}

export interface TripUrlParams extends ItineraryParams {
    adultCount: number;
    childCount: number;
    infantCount: number;
    origin: string;
    destination: string;
    departureDate: Date;
    returnDate?: Date;
}

export interface UrlRoute {
    origin: string;
    destination: string;
    departureDate: Date;
    returnDate?: Date;
}
